"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var __1 = require("../../..");
var component_1 = require("../../../component");
var element_1 = require("../../../element");
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ribbon.prototype.init = function () {
        var _this = this;
        this.appendGroupT(element_1.Path).options({
            _data: function (d) { return d; },
            d: function (d, i, g) {
                var circos = _this.parent.parent.parent;
                var ribbon = d3.ribbon();
                var sourceScale = function (x) { return circos.xScaleForChr(d.source.key)(x) * Math.PI / 180; };
                var targetScale = function (x) { return circos.xScaleForChr(d.target.key)(x) * Math.PI / 180; };
                return ribbon({
                    source: {
                        startAngle: sourceScale(d.source.from),
                        endAngle: sourceScale(d.source.to),
                        radius: circos.innerRBySection(d.source.key),
                    },
                    target: {
                        startAngle: targetScale(d.target.from),
                        endAngle: targetScale(d.target.to),
                        radius: circos.innerRBySection(d.target.key),
                    },
                });
            },
            fill: "#aaa",
            "fill-opacity": 0.5,
        });
    };
    return Ribbon;
}(component_1.Component));
exports.Ribbon = Ribbon;
var Chord = /** @class */ (function (_super) {
    __extends(Chord, _super);
    function Chord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chord.prototype.init = function () {
        var _this = this;
        var chord = d3.line()
            .x(function (d) { return d[0]; })
            .y(function (d) { return d[1]; })
            .curve(d3.curveBundle.beta(0.85));
        this._chord = this.appendGroupT(element_1.Path).options({
            _data: function (d) { return d; },
            d: function (d, i, g) {
                var circos = _this.parent.parent.parent;
                var sourceScale = circos.xScaleForChr(d.source.key);
                var targetScale = circos.xScaleForChr(d.target.key);
                return chord([
                    __1.tool.polar2cart(sourceScale(d.source.pos), circos.innerRBySection(d.source.key)),
                    [0, 0],
                    __1.tool.polar2cart(targetScale(d.target.pos), circos.innerRBySection(d.target.key)),
                ]);
            },
            stroke: "#aaa",
            fill: "none",
            "fill-opacity": 0.5,
        });
    };
    Chord.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this.setupProxy({
            chord: "_chord",
        });
    };
    return Chord;
}(component_1.Component));
exports.Chord = Chord;
//# sourceMappingURL=chord.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/chord.js
// module id = 1179
// module chunks = 0 1